import { useIsDesktopLayout } from './useMediaQuery';

const useIsDesktopLayoutWrapper = () => {
  return useIsDesktopLayout();
};

export default useIsDesktopLayoutWrapper;
